import type { ListingDetails } from './listingDetails';
import type { ListingSuggestion } from './listingSearch';

/**
 * Texas is the default rollout cohort. Non-Texas navigation crosses the edge
 * so its global entry flag decides which application serves the property.
 */
const ROLLOUT_STATE = 'TX';

/**
 * Rails builds listing slugs from the address
 * (`<Street>[-<Unit>]-<City>-<STATE>-<zip>`, plus a numeric id on collision),
 * so a suggestion's slug names its state. A slug that does not parse is
 * treated as out of state.
 */
const SLUG_STATE_PATTERN = /-([A-Za-z]{2})-\d{5}(?:-\d+)*$/;

export const isTexasSuggestion = (suggestion: ListingSuggestion): boolean =>
  SLUG_STATE_PATTERN.exec(suggestion.slug)?.[1]?.toUpperCase() === ROLLOUT_STATE;

export const isTexasListing = (listing: ListingDetails): boolean =>
  listing.address.state?.toUpperCase() === ROLLOUT_STATE;
